import { Slot } from "@radix-ui/react-slot"
import type { ComponentProps } from "react"
import { disabledVariants } from "../../styles"
import { classNames } from "../../utils"
import type { SlotProps } from "../Slot"

export type UnstyledButtonProps = Omit<
  ComponentProps<"button"> & SlotProps<"button">,
  "content"
>

export function UnstyledButton({
  asChild,
  className,
  disabled,
  ...rest
}: UnstyledButtonProps) {
  const Comp = asChild ? Slot : "button"

  return (
    <Comp
      className={classNames(
        "inline-flex items-center",
        disabledVariants({ disabled }),
        className,
      )}
      disabled={disabled}
      type="button"
      {...rest}
    />
  )
}
